import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Input } from "../components/ui/input";
import { Euro, RefreshCw, CheckCircle } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function StripeReportPage() {
  const [data, setData] = useState({ lignes: [], total_encaisse: 0, total_rembourse: 0, nombre: 0 });
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [q, setQ] = useState("");

  const load = async () => {
    setLoading(true); setErr("");
    try {
      const r = await axios.get(`${API}/api/stripe-report`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setData(r.data || { lignes: [] });
    } catch (e) {
      setErr(e.response?.data?.detail || "Erreur lors de la recuperation Stripe.");
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const rows = (data.lignes || []).filter((l) =>
    !q || (l.description || "").toLowerCase().includes(q.toLowerCase()) ||
    (l.email || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <h1 className="text-xl sm:text-2xl font-bold text-secondary">Paiements Stripe</h1>
          <p className="text-sm text-gray-500">Paiements recus en direct depuis Stripe.</p>
        </div>
        <button onClick={load} className="inline-flex items-center gap-2 text-sm border rounded-md px-3 py-2 hover:bg-gray-50">
          <RefreshCw className="w-4 h-4" /> Actualiser
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        <Card><CardContent className="p-4 flex items-center gap-3"><Euro className="w-5 h-5 text-green-600" />
          <div><div className="text-2xl font-bold text-secondary">{data.total_encaisse} €</div><div className="text-xs text-gray-500">Total encaisse</div></div></CardContent></Card>
        <Card><CardContent className="p-4 flex items-center gap-3"><RefreshCw className="w-5 h-5 text-amber-500" />
          <div><div className="text-2xl font-bold text-secondary">{data.total_rembourse} €</div><div className="text-xs text-gray-500">Rembourse</div></div></CardContent></Card>
        <Card><CardContent className="p-4 flex items-center gap-3"><CheckCircle className="w-5 h-5 text-blue-600" />
          <div><div className="text-2xl font-bold text-secondary">{data.nombre}</div><div className="text-xs text-gray-500">Transactions</div></div></CardContent></Card>
      </div>

      <div className="flex items-center gap-3">
        <Input className="max-w-xs" placeholder="Rechercher (description, email)" value={q} onChange={(e) => setQ(e.target.value)} />
        <span className="text-sm text-gray-500">{rows.length} ligne(s)</span>
      </div>

      {err && <p className="text-red-600 text-sm">{err}</p>}

      <Card>
        <CardHeader><CardTitle className="text-lg">Transactions</CardTitle></CardHeader>
        <CardContent className="overflow-x-auto">
          {loading ? (<p className="text-sm text-gray-500">Chargement...</p>) : (
            <table className="w-full text-sm">
              <thead><tr className="text-left text-gray-500 border-b">
                <th className="py-2 pr-3">Date</th><th className="py-2 pr-3">Montant</th>
                <th className="py-2 pr-3">Statut</th><th className="py-2 pr-3">Description</th>
                <th className="py-2 pr-3">Email</th></tr></thead>
              <tbody>
                {rows.map((l, i) => (
                  <tr key={i} className="border-b hover:bg-gray-50">
                    <td className="py-2 pr-3 whitespace-nowrap">{l.date}</td>
                    <td className="py-2 pr-3 whitespace-nowrap font-medium">{l.montant} {l.devise}{l.rembourse > 0 ? <span className="text-amber-600 text-xs"> (-{l.rembourse})</span> : null}</td>
                    <td className="py-2 pr-3">{l.paye ? (<Badge className="bg-green-600">payé</Badge>) : (<Badge variant="outline">{l.statut}</Badge>)}</td>
                    <td className="py-2 pr-3">{l.description || "-"}</td>
                    <td className="py-2 pr-3">{l.email || "-"}</td>
                  </tr>
                ))}
                {rows.length === 0 && (<tr><td colSpan={5} className="py-4 text-center text-gray-400">Aucune transaction.</td></tr>)}
              </tbody>
            </table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
